// extracted by mini-css-extract-plugin
export default {"orderConfirm":"OrderConfirm_orderConfirm__XDdjp","orderConfirmLink":"OrderConfirm_orderConfirmLink__cmrWw"};